module.exports = __webpack_public_path__ + "static/media/xiangmudingdanchengbenhesuanbiao.956345d9.png";